<script lang="ts">
    import Overlay from "./Overlay.svelte";

    export let open: boolean = false;

    export let onClose: () => void;
</script>

{#if open}
    <Overlay onClick={onClose}>
        <slot />
    </Overlay>
{/if}
